(() => {
  const form = document.getElementById('SellCollectionForm');
  const button = form?.querySelector('[data-sell-whatsapp]');
  if (!button || button.dataset.ready) return;
  button.dataset.ready = 'true';
  button.hidden = false;
  button.addEventListener('click', () => {
    for (const id of ['sell-name', 'sell-details']) {
      const field = form.querySelector('#' + id);
      field.setCustomValidity(field.value.trim() ? '' : 'Please fill in this field.');
      if (!field.reportValidity()) {
        field.addEventListener('input', () => field.setCustomValidity(''), { once: true });
        return;
      }
    }
    const lines = ['Hi Geek Out, I have a collection to sell.'];
    const fields = [['sell-name', 'Name'], ['sell-type', 'Collection'], ['sell-location', 'Location'], ['sell-email', 'Email'], ['sell-phone', 'Phone'], ['sell-details', 'Details']];
    for (const [id, label] of fields) {
      const value = form.querySelector('#' + id).value.trim();
      if (value) lines.push(label + ': ' + value);
    }
    const number = button.dataset.sellWhatsapp.replace(/\D/g, '');
    window.open('https://wa.me/' + number + '?text=' + encodeURIComponent(lines.join('\n\n')), '_blank', 'noopener,noreferrer');
  });
})();
